import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import FadeIn from 'react-fade-in';
import { Box, Card, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Page from 'src/components/Page';
import Preloader from 'src/components/Preloader';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import {
  loadInsuranceDetail,
  LOAD_INSURANCE_DETAIL
} from 'src/store/actions/insuranceActions';
import { selectInsuranceDetail } from 'src/store/selectors/insuranceSelector';
import InsuranceTabs from './InsuranceTabs';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  preloaderCard: {
    height: '82vh'
  }
}));

const InsuranceDetailView = () => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { policyId } = useParams();
  const insurance = useSelector(selectInsuranceDetail);
  const loadingInsurance = useSelector(
    isLoadingSelector([LOAD_INSURANCE_DETAIL.action])
  );

  const success = useSelector(successSelector([LOAD_INSURANCE_DETAIL.action]));

  useEffect(() => {
    if (policyId) {
      dispatch(loadInsuranceDetail(policyId));
    }
  }, [dispatch, policyId]);

  return (
    <Page
      className={classes.root}
      title={`Insurance ${insurance ? policyId : ''}`}
    >
      <FadeIn transitionDuration={300}>
        <Container maxWidth={false}>
          <Box>
            {success && !loadingInsurance && insurance ? (
              <InsuranceTabs insurance={insurance} />
            ) : (
              <Card className={classes.preloaderCard}>
                <Preloader />
              </Card>
            )}
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default InsuranceDetailView;
